module.exports = __webpack_public_path__ + "prod/1.42.2/img/success-cases-two-bg.05d2cbcc.png";